import * as React from "react";
import styled from "@mui/material/styles/styled";
import { PatientColorMap } from "../layout/patientColorMap";
import { GenderValue } from "shared";
import { ReactComponent as MaleIcon } from "../assets/maleIcon.svg";
import { ReactComponent as FemaleIcon } from "../assets/femaleIcon.svg";
import { usePatient } from "../state/patientContext";
import { useTranslate } from "../hooks/useTranslate";

//region [[ Styles ]]

const ProfileHeaderView = styled("div")(({ theme }) => ({
  backgroundColor: PatientColorMap.Background,
  display: "flex",
  alignItems: "center",
  padding: "20px",
  marginBottom: "10px",
  flexDirection: "column",
  justifyContent: "center",
}));

const MaleIconStyled = styled(MaleIcon)(({ theme }) => ({
  height: "54px",
  width: "54px",
}));

const FemaleIconStyled = styled(FemaleIcon)(({ theme }) => ({
  height: "54px",
  width: "54px",
}));

const GenderIcon = styled("div")(({ theme }) => ({
  marginBottom: "5px",
}));

const SummaryText = styled("div")(({ theme }) => ({}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ProfileHeaderProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ProfileHeader = ({ ...props }: ProfileHeaderProps) => {
  const { gender } = usePatient();
  const { translate } = useTranslate();
  const GENDER_MALE = "MALE";
  const GENDER_FEMALE = "FEMALE";
  const age = "21";

  const genderText = translate(
    gender === GenderValue.MALE ? GENDER_MALE : GENDER_FEMALE,
  );

  const ageText = age ? `, ${age}` : "";

  return (
    <ProfileHeaderView>
      <GenderIcon>
        {gender === GenderValue.MALE ? (
          <MaleIconStyled />
        ) : (
          <FemaleIconStyled />
        )}
      </GenderIcon>
      <SummaryText>
        <div> {`${genderText}${ageText}`}</div>
      </SummaryText>
    </ProfileHeaderView>
  );
};
